import React from "react";
import PropTypes from "prop-types";
import { Container, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Layout from "../../components/Layout";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      alignContent: "center",
      alignItems: "center",
      display: "grid",
      gap: `${theme.spacing(4)}px`,
      gridArea: "content",
      justifyItems: "center",
      paddingBottom: theme.spacing(4),
      paddingTop: theme.spacing(4)
    },
    form: {
      display: "grid",
      gap: `${theme.spacing(2)}px`,
      paddingBottom: theme.spacing(4),
      paddingTop: theme.spacing(4),
      width: "50%"
    }
  })
);

export const Thanks = ({ location }): ReactElement => {
  const classes = useStyles();

  return (
    <Layout pathname={location.pathname}>
      <Container className={classes.root} component="main" fixed>
        <Typography component="h1" variant="h4">
          Thank you!
        </Typography>
        <p>We will respond to your query as quickly as possible.</p>
      </Container>
    </Layout>
  );
};

Thanks.propTypes = {
  location: PropTypes.object
};

export default Thanks;
